import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "@emotion/react";

import { motion, AnimatePresence } from "framer-motion";

// POLYFILLS
import "url-search-params-polyfill";

import "remixicon/fonts/remixicon.css";

import {
  Box,
  ColorMode,
  Footer,
  GlobalStyles,
  Header,
  Theme,
} from "components";

import "./fonts.css";

function Layout({ children, location }) {
  useEffect(() => {
    // Set static viewport height unit on resize and on load
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }, []);

  return (
    <ThemeProvider theme={Theme}>
      <>
        <GlobalStyles />
        <ColorMode mode="light">
          <>
            <Box display="flex" flexDirection="column" minHeight="100vh">
              <Header path={location.pathname} />
              <AnimatePresence>
                <motion.main
                  variants={{
                    initial: {
                      opacity: 0,
                    },
                    enter: {
                      opacity: 1,
                      transition: {
                        duration: 0.3,
                        delay: 0.3,
                      },
                    },
                    exit: {
                      opacity: 0,
                      transition: { duration: 0.2 },
                    },
                  }}
                  key={location.pathname}
                  initial="initial"
                  animate="enter"
                  exit="exit"
                >
                  {children}
                </motion.main>
              </AnimatePresence>
              <Footer />
            </Box>
          </>
        </ColorMode>
      </>
    </ThemeProvider>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
